// This file is automatically generated. See gqlcodegen.yml for details
import * as CustomScalars from "./scalars";
export var ActionType = {
    ACTIVITY_ADD: 'ACTIVITY_ADD',
    ACTIVITY_RATE: 'ACTIVITY_RATE',
    BREATH_HOLDING: 'BREATH_HOLDING',
    COPING_CARD_ADD: 'COPING_CARD_ADD',
    COPING_CARD_REVIEW: 'COPING_CARD_REVIEW',
    EATING_LOG_ADD: 'EATING_LOG_ADD',
    HOPE_KIT_ADD: 'HOPE_KIT_ADD',
    HOPE_KIT_REVIEW: 'HOPE_KIT_REVIEW',
    HYPERVENTILATION: 'HYPERVENTILATION',
    MY_PLAN_REVIEW: 'MY_PLAN_REVIEW',
    RELAX: 'RELAX',
    SLEEP_DIARY_ENTRY_MORNING: 'SLEEP_DIARY_ENTRY_MORNING',
    SLEEP_DIARY_ENTRY_NIGHT: 'SLEEP_DIARY_ENTRY_NIGHT',
    STATIC_01: 'STATIC_01',
    STATIC_02: 'STATIC_02',
    STATIC_03: 'STATIC_03',
    STATIC_04: 'STATIC_04',
    STATIC_05: 'STATIC_05',
    STATIC_06: 'STATIC_06',
    STATIC_07: 'STATIC_07',
    STATIC_08: 'STATIC_08',
    STATIC_09: 'STATIC_09',
    STATIC_10: 'STATIC_10',
    STATIC_11: 'STATIC_11',
    STATIC_12: 'STATIC_12',
    THOUGHT_DIARY_SPOT: 'THOUGHT_DIARY_SPOT',
    THOUGHT_DIARY_SWITCH: 'THOUGHT_DIARY_SWITCH',
    THOUGHT_DIARY_TEST: 'THOUGHT_DIARY_TEST',
    WORD_PAIRING: 'WORD_PAIRING'
};
export var AddressUse = {
    HOME: 'HOME',
    OLD: 'OLD',
    TEMP: 'TEMP',
    WORK: 'WORK'
};
export var AppActivityName = {
    ACTIVITYDIARY: 'ActivityDiary',
    BINGEEATINGMYPLAN: 'BingeEatingMyPlan',
    BREATHHOLDING: 'BreathHolding',
    COPINGCARDS: 'CopingCards',
    CRISISFRAMEWORK: 'CrisisFramework',
    EATINGLOG: 'EatingLog',
    EDITEATINGSCHEDULE: 'EditEatingSchedule',
    HOPEKIT: 'HopeKit',
    HYPERVENTILATION: 'Hyperventilation',
    MYPLANREVIEW: 'MyPlanReview',
    RELAXATION: 'Relaxation',
    RISKCURVE: 'RiskCurve',
    SLEEPDIARY: 'SleepDiary',
    SOLOMYPLAN: 'SoloMyPlan',
    SOLORISKCURVE: 'SoloRiskCurve',
    SOLOSUICIDEMODE: 'SoloSuicideMode',
    STRESSSENSITIVITYASSESSMENT: 'StressSensitivityAssessment',
    SUICIDEMODE: 'SuicideMode',
    THOUGHTDIARY: 'ThoughtDiary',
    WORDPAIRING: 'WordPairing'
};
export var CaringContactsMedium = {
    EMAIL: 'EMAIL',
    MAIL: 'MAIL',
    NONE: 'NONE',
    SMS: 'SMS'
};
export var CompositionTemplate = {
    BINGE_EATING_MY_PLAN: 'BINGE_EATING_MY_PLAN',
    EATING_COMMITMENT: 'EATING_COMMITMENT',
    EATING_SCHEDULE: 'EATING_SCHEDULE',
    MYSTORYMYPLAN: 'MYSTORYMYPLAN',
    MYSTORYMYPLAN_CLINICAL: 'MYSTORYMYPLAN_CLINICAL',
    SCREENER_CSSRS: 'SCREENER_CSSRS',
    SCREENER_NUMERIC: 'SCREENER_NUMERIC',
    STRESS_SENSITIVITY_ASSESSMENT: 'STRESS_SENSITIVITY_ASSESSMENT',
    TEST: 'TEST',
    YST_MENTAL_HEALTH_CONCERNS: 'YST_MENTAL_HEALTH_CONCERNS'
};
export var ContactPointSystem = {
    EMAIL: 'EMAIL',
    FAX: 'FAX',
    OTHER: 'OTHER',
    PAGER: 'PAGER',
    PHONE: 'PHONE',
    SMS: 'SMS',
    URL: 'URL'
};
export var ContactPointUse = {
    HOME: 'HOME',
    MOBILE: 'MOBILE',
    OLD: 'OLD',
    TEMP: 'TEMP',
    WORK: 'WORK'
};
export var ContentType = {
    ACTIVITY_PLANNING: 'ACTIVITY_PLANNING',
    ANXIETY_CAUSES: 'ANXIETY_CAUSES',
    BODY_IMAGE: 'BODY_IMAGE',
    BREATH_HOLDING: 'BREATH_HOLDING',
    COPING_CARDS: 'COPING_CARDS',
    EATING_THE_RIGHT_FOODS: 'EATING_THE_RIGHT_FOODS',
    ENVIRONMENT_SAFETY: 'ENVIRONMENT_SAFETY',
    EXERCISE_AND_SLEEP: 'EXERCISE_AND_SLEEP',
    HOPE_KIT: 'HOPE_KIT',
    HOW_TO_HELP: 'HOW_TO_HELP',
    HYPERVENTILATION: 'HYPERVENTILATION',
    MOOD_MODULATION: 'MOOD_MODULATION',
    MOOD_TOLERANCE: 'MOOD_TOLERANCE',
    MYPLAN: 'MYPLAN',
    MYPLAN_REVIEW: 'MYPLAN_REVIEW',
    MYSTORYMYPLAN: 'MYSTORYMYPLAN',
    OVEREATING_CYCLE: 'OVEREATING_CYCLE',
    POST_AVIVA: 'POST_AVIVA',
    REDUCE_RISK: 'REDUCE_RISK',
    REGULAR_EATING: 'REGULAR_EATING',
    RELAPSE_PREVENTION: 'RELAPSE_PREVENTION',
    RELAXATION: 'RELAXATION',
    REMOVING_BARRIERS: 'REMOVING_BARRIERS',
    REVIEW_PREVENT_PRACTICE: 'REVIEW_PREVENT_PRACTICE',
    SLEEP: 'SLEEP',
    SOCIAL_SUPPORT: 'SOCIAL_SUPPORT',
    SPOT_IT: 'SPOT_IT',
    STATIC_01: 'STATIC_01',
    STATIC_02: 'STATIC_02',
    STATIC_03: 'STATIC_03',
    STATIC_04: 'STATIC_04',
    STATIC_05: 'STATIC_05',
    STATIC_06: 'STATIC_06',
    STATIC_07: 'STATIC_07',
    STATIC_08: 'STATIC_08',
    STATIC_09: 'STATIC_09',
    STATIC_10: 'STATIC_10',
    STATIC_11: 'STATIC_11',
    STATIC_12: 'STATIC_12',
    SWITCH_IT: 'SWITCH_IT',
    TEST: 'TEST',
    TEST_IT: 'TEST_IT',
    THINK_CLEAR: 'THINK_CLEAR',
    URGE_SURFING: 'URGE_SURFING',
    V1_SESSION_01: 'V1_SESSION_01',
    V1_SESSION_02: 'V1_SESSION_02',
    V1_SESSION_03: 'V1_SESSION_03',
    V1_SESSION_04: 'V1_SESSION_04',
    V1_SESSION_05: 'V1_SESSION_05',
    V1_SESSION_06: 'V1_SESSION_06',
    V1_SESSION_06P: 'V1_SESSION_06P',
    V1_SESSION_07: 'V1_SESSION_07',
    V1_SESSION_07P: 'V1_SESSION_07P',
    V1_SESSION_08: 'V1_SESSION_08',
    V1_SESSION_08P: 'V1_SESSION_08P',
    V1_SESSION_09: 'V1_SESSION_09',
    V1_SESSION_09P: 'V1_SESSION_09P',
    V1_SESSION_10: 'V1_SESSION_10',
    V1_SESSION_10P: 'V1_SESSION_10P',
    V1_WELCOME: 'V1_WELCOME',
    WEIGHT_STIGMA: 'WEIGHT_STIGMA',
    WORD_PAIRING: 'WORD_PAIRING'
};
export var CrisisFramework = {
    RISK_CURVE_TIMELINE: 'RISK_CURVE_TIMELINE',
    SUICIDE_MODE: 'SUICIDE_MODE'
};
export var EatingCheckinCompletionButton = {
    DONE: 'DONE',
    SUGGESTION: 'SUGGESTION'
};
export var EatingCheckinTrigger = {
    EATING_LOG: 'EATING_LOG',
    SESSION: 'SESSION'
};
export var EatingCommitmentHealthyFood = {
    FRUITS: 'FRUITS',
    GRAINS: 'GRAINS',
    HEALTHY_FATS: 'HEALTHY_FATS',
    LEAN_MEATS: 'LEAN_MEATS',
    OTHER: 'OTHER',
    VEGETABLES: 'VEGETABLES'
};
export var EatingCommitmentUnhealthyFood = {
    CANDY: 'CANDY',
    DESSERTS: 'DESSERTS',
    JUNK_FOOD: 'JUNK_FOOD',
    OTHER: 'OTHER',
    SODA: 'SODA',
    TAKEOUT: 'TAKEOUT'
};
export var EatingLogMealType = {
    BREAKFAST: 'BREAKFAST',
    DINNER: 'DINNER',
    LUNCH: 'LUNCH',
    SNACK: 'SNACK'
};
export var EatingProgressWeightUnit = {
    KG: 'KG',
    LBS: 'LBS'
};
export var EntityType = {
    GQL_MUTATION: 'GQL_MUTATION',
    GQL_QUERY: 'GQL_QUERY',
    ORGANIZATION: 'ORGANIZATION',
    ORGANIZATION_PRODUCT: 'ORGANIZATION_PRODUCT',
    ROLE: 'ROLE',
    USER: 'USER'
};
export var FileUploadType = {
    APP_LOGO: 'APP_LOGO',
    CHAT_IMAGE: 'CHAT_IMAGE',
    ILLUSTRATION: 'ILLUSTRATION',
    QUIZ_SET_VIDEO: 'QUIZ_SET_VIDEO',
    VIDEO: 'VIDEO',
    VIDEO_TEXT_TRACK: 'VIDEO_TEXT_TRACK'
};
export var JobStatus = {
    CREATED: 'CREATED',
    ERROR: 'ERROR',
    QUEUED: 'QUEUED',
    RUNNING: 'RUNNING',
    SUCCESS: 'SUCCESS'
};
export var JobType = {
    AMPLITUDE_IMPORT: 'AMPLITUDE_IMPORT',
    CHANGEBITE_NOTIFICATIONS: 'CHANGEBITE_NOTIFICATIONS',
    CHECK_EXPO_PUSH_RECEIPTS: 'CHECK_EXPO_PUSH_RECEIPTS',
    DETOX_USER_CLEANUP: 'DETOX_USER_CLEANUP',
    EMAIL_USERS: 'EMAIL_USERS',
    ENQUEUE_JOBS: 'ENQUEUE_JOBS',
    EXPIRED_USER_SESSION_CLEANUP: 'EXPIRED_USER_SESSION_CLEANUP',
    GROUP_SESSIONS: 'GROUP_SESSIONS',
    INVITE_YST_NOMINEE: 'INVITE_YST_NOMINEE',
    LOG: 'LOG',
    MEAL_REMINDER: 'MEAL_REMINDER',
    MY_PLAN_UPDATED_SUPPORTER_NOTIFICATION: 'MY_PLAN_UPDATED_SUPPORTER_NOTIFICATION',
    NORMALIZE_AMPLITUDE_EVENT_SESSION_START: 'NORMALIZE_AMPLITUDE_EVENT_SESSION_START',
    NORMALIZE_USERS_PHONE: 'NORMALIZE_USERS_PHONE',
    OTX202_DATA_EXPORT: 'OTX202_DATA_EXPORT',
    PATIENTS_PROGRESS_STARTED_AT_FOR_PRODUCT_STATIC_BACKFILL: 'PATIENTS_PROGRESS_STARTED_AT_FOR_PRODUCT_STATIC_BACKFILL',
    PATIENT_CARING_CONTACTS: 'PATIENT_CARING_CONTACTS',
    PATIENT_NOTIFICATIONS: 'PATIENT_NOTIFICATIONS',
    PATIENT_SPOOL: 'PATIENT_SPOOL',
    PROCESS_VIDEO_ASSET: 'PROCESS_VIDEO_ASSET',
    PTSD_NOTIFICATIONS: 'PTSD_NOTIFICATIONS',
    SEND_EMAIL: 'SEND_EMAIL',
    SLEEP: 'SLEEP',
    SYNC_GCS_MEDIA_UPLOAD: 'SYNC_GCS_MEDIA_UPLOAD',
    TEST_RECORD_CLEANUP: 'TEST_RECORD_CLEANUP',
    UNLOCK_SESSIONS: 'UNLOCK_SESSIONS',
    YST_NEW_SIGNUP_EMAIL: 'YST_NEW_SIGNUP_EMAIL',
    YST_NOMINATION_REMINDER: 'YST_NOMINATION_REMINDER',
    YST_REPORTS: 'YST_REPORTS',
    YST_SUPPORTER: 'YST_SUPPORTER'
};
export var LegacyUserGender = {
    FEMALE: 'FEMALE',
    MALE: 'MALE',
    NOANSWER: 'NOANSWER',
    OTHER: 'OTHER'
};
export var LegacyUserRace = {
    ASIAN: 'ASIAN',
    BLACK: 'BLACK',
    NATIVE: 'NATIVE',
    NOANSWER: 'NOANSWER',
    OTHER: 'OTHER',
    PACIFIC: 'PACIFIC',
    WHITE: 'WHITE'
};
export var LegacyUserSexuality = {
    BISEXUAL: 'BISEXUAL',
    HETEROSEXUAL: 'HETEROSEXUAL',
    HOMOSEXUAL: 'HOMOSEXUAL',
    NOANSWER: 'NOANSWER'
};
export var MediaAction = {
    FILE_UPLOAD_TO_GCS: 'FILE_UPLOAD_TO_GCS',
    MUX_HOSTING: 'MUX_HOSTING',
    REV_CAPTIONING: 'REV_CAPTIONING'
};
export var MuxFitMode = {
    CROP: 'crop',
    PAD: 'pad',
    PRESERVE: 'preserve',
    SMARTCROP: 'smartcrop'
};
export var OnboardingVariant = {
    COLLABORATIVE: 'COLLABORATIVE',
    INDEPENDENT: 'INDEPENDENT'
};
export var OuiUserRoleType = {
    OUI_ADMIN: 'OUI_ADMIN',
    PATIENT: 'PATIENT',
    PRACTITIONER: 'PRACTITIONER',
    REGISTRAR: 'REGISTRAR',
    UNKNOWN: 'UNKNOWN'
};
export var PatientGenderIdentity = {
    FEMALE: 'FEMALE',
    MALE: 'MALE',
    NON_BINARY: 'NON_BINARY',
    NON_DISCLOSE: 'NON_DISCLOSE',
    TRANSGENDER_FEMALE: 'TRANSGENDER_FEMALE',
    TRANSGENDER_MALE: 'TRANSGENDER_MALE',
    UNKNOWN: 'UNKNOWN'
};
export var PatientMilitaryStatus = {
    ACTIVE_MILITARY_DUTY: 'ACTIVE_MILITARY_DUTY',
    CIVILIAN: 'CIVILIAN',
    DISABLED_VETERAN: 'DISABLED_VETERAN',
    FAMILY_MEMBER_OF_ACTIVE_DUTY: 'FAMILY_MEMBER_OF_ACTIVE_DUTY',
    FAMILY_MEMBER_OF_RETIRED_MILITARY: 'FAMILY_MEMBER_OF_RETIRED_MILITARY',
    INACTIVE_READY_RESERVE: 'INACTIVE_READY_RESERVE',
    NATIONAL_GUARD: 'NATIONAL_GUARD',
    NON_DISCLOSE: 'NON_DISCLOSE',
    RESERVES: 'RESERVES',
    RETIRED_MILITARY: 'RETIRED_MILITARY',
    UNKNOWN: 'UNKNOWN',
    VETERAN: 'VETERAN'
};
export var PatientRace = {
    AMERICAN_INDIAN_OR_ALASKA_NATIVE: 'AMERICAN_INDIAN_OR_ALASKA_NATIVE',
    ASIAN: 'ASIAN',
    BLACK_OR_AFRICAN_AMERICAN: 'BLACK_OR_AFRICAN_AMERICAN',
    NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER: 'NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER',
    NON_DISCLOSE: 'NON_DISCLOSE',
    UNKNOWN: 'UNKNOWN',
    WHITE: 'WHITE'
};
export var PatientSexualOrientation = {
    BISEXUAL: 'BISEXUAL',
    HETEROSEXUAL: 'HETEROSEXUAL',
    HOMOSEXUAL: 'HOMOSEXUAL',
    NON_DISCLOSE: 'NON_DISCLOSE',
    OTHER: 'OTHER',
    UNKNOWN: 'UNKNOWN'
};
export var PatientSupporterRelation = {
    CLINICIAN: 'CLINICIAN',
    OTHER: 'OTHER',
    PARENT_GUARDIAN: 'PARENT_GUARDIAN',
    RELATIVE: 'RELATIVE',
    SOCIAL_SERVICES: 'SOCIAL_SERVICES'
};
export var PracticeType = {
    ACTIVITY: 'ACTIVITY',
    BREATH_HOLDING: 'BREATH_HOLDING',
    EATING_CHECKIN: 'EATING_CHECKIN',
    EATING_COMMITMENT_ENTRY: 'EATING_COMMITMENT_ENTRY',
    EATING_LOG_ENTRY: 'EATING_LOG_ENTRY',
    EATING_PROGRESS_ENTRY: 'EATING_PROGRESS_ENTRY',
    HYPERVENTILATION: 'HYPERVENTILATION',
    RELAX_DIARY_ENTRY: 'RELAX_DIARY_ENTRY',
    SLEEP_DIARY_ENTRY: 'SLEEP_DIARY_ENTRY',
    THOUGHT_DIARY_ENTRY: 'THOUGHT_DIARY_ENTRY',
    WORD_PAIRING: 'WORD_PAIRING'
};
export var ProductVariant = {
    AVIVA_ADOLESCENT: 'AVIVA_ADOLESCENT',
    AVIVA_ADULT: 'AVIVA_ADULT',
    AVIVA_INPATIENT: 'AVIVA_INPATIENT',
    AVIVA_MILITARY: 'AVIVA_MILITARY',
    AVIVA_STATIC: 'AVIVA_STATIC',
    AVIVA_SUPPORT: 'AVIVA_SUPPORT',
    OUI_PLATFORM: 'OUI_PLATFORM',
    YST_GUARDIAN: 'YST_GUARDIAN',
    YST_SUPPORT: 'YST_SUPPORT',
    YST_YOUTH: 'YST_YOUTH'
};
export var ProductVersion = {
    AVIVA_1_1: 'AVIVA_1_1',
    AVIVA_2_0: 'AVIVA_2_0'
};
/** Deprecated - use productStatic instead */ export var PtsdDosageVersion = {
    V1: 'V1',
    V2: 'V2'
};
export var QuizSetItemType = {
    MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
    SINGLE_CHOICE: 'SINGLE_CHOICE',
    VIDEO: 'VIDEO'
};
export var RatingDuration = {
    ALL: 'ALL',
    DAY: 'DAY',
    MONTH: 'MONTH',
    WEEK: 'WEEK',
    YEAR: 'YEAR'
};
export var RatingType = {
    QUALITY: 'QUALITY',
    RATING: 'RATING',
    RATING_AFTER: 'RATING_AFTER',
    RATING_BEFORE: 'RATING_BEFORE'
};
export var RoleType = {
    GUARDIAN: 'GUARDIAN',
    PATIENT: 'PATIENT',
    PRACTITIONER: 'PRACTITIONER',
    REGISTRAR: 'REGISTRAR',
    SUPPORTER: 'SUPPORTER'
};
export var SessionState = {
    COMPLETED: 'COMPLETED',
    IN_PROGRESS: 'IN_PROGRESS',
    LOCKED: 'LOCKED',
    UNLOCKED: 'UNLOCKED'
};
export var SleepDiaryEntryDuration = {
    DURATION_1_TO_5: 'DURATION_1_TO_5',
    DURATION_5_TO_10: 'DURATION_5_TO_10',
    DURATION_15_TO_30: 'DURATION_15_TO_30',
    DURATION_20_TO_45: 'DURATION_20_TO_45',
    DURATION_30_TO_60: 'DURATION_30_TO_60',
    DURATION_45_TO_60: 'DURATION_45_TO_60',
    DURATION_60_TO_120: 'DURATION_60_TO_120',
    DURATION_120_TO_180: 'DURATION_120_TO_180',
    DURATION_LESS_THAN_15: 'DURATION_LESS_THAN_15',
    DURATION_MORE_THAN_60: 'DURATION_MORE_THAN_60',
    DURATION_MORE_THAN_120: 'DURATION_MORE_THAN_120',
    DURATION_MORE_THAN_180: 'DURATION_MORE_THAN_180'
};
export var SleepDiaryEntryTimeOfDay = {
    AFTERNOON: 'AFTERNOON',
    EVENING: 'EVENING',
    MORNING: 'MORNING',
    NIGHT: 'NIGHT'
};
export var UploadType = {
    AUDIO: 'AUDIO',
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO'
};
export var UsageDuration = {
    DAY: 'DAY',
    MONTH: 'MONTH',
    WEEK: 'WEEK'
};
export var UserGenderIdentity = {
    FEMALE: 'FEMALE',
    MALE: 'MALE',
    NON_BINARY: 'NON_BINARY',
    NON_DISCLOSE: 'NON_DISCLOSE',
    TRANSGENDER_FEMALE: 'TRANSGENDER_FEMALE',
    TRANSGENDER_MALE: 'TRANSGENDER_MALE',
    UNKNOWN: 'UNKNOWN'
};
export var UserMilitaryStatus = {
    ACTIVE_MILITARY_DUTY: 'ACTIVE_MILITARY_DUTY',
    CIVILIAN: 'CIVILIAN',
    DISABLED_VETERAN: 'DISABLED_VETERAN',
    FAMILY_MEMBER_OF_ACTIVE_DUTY: 'FAMILY_MEMBER_OF_ACTIVE_DUTY',
    FAMILY_MEMBER_OF_RETIRED_MILITARY: 'FAMILY_MEMBER_OF_RETIRED_MILITARY',
    INACTIVE_READY_RESERVE: 'INACTIVE_READY_RESERVE',
    NATIONAL_GUARD: 'NATIONAL_GUARD',
    NON_DISCLOSE: 'NON_DISCLOSE',
    RESERVES: 'RESERVES',
    RETIRED_MILITARY: 'RETIRED_MILITARY',
    UNKNOWN: 'UNKNOWN',
    VETERAN: 'VETERAN'
};
export var UserRace = {
    AMERICAN_INDIAN_OR_ALASKA_NATIVE: 'AMERICAN_INDIAN_OR_ALASKA_NATIVE',
    ASIAN: 'ASIAN',
    BLACK_OR_AFRICAN_AMERICAN: 'BLACK_OR_AFRICAN_AMERICAN',
    NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER: 'NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER',
    NON_DISCLOSE: 'NON_DISCLOSE',
    UNKNOWN: 'UNKNOWN',
    WHITE: 'WHITE'
};
export var UserSexualOrientation = {
    BISEXUAL: 'BISEXUAL',
    HETEROSEXUAL: 'HETEROSEXUAL',
    HOMOSEXUAL: 'HOMOSEXUAL',
    NON_DISCLOSE: 'NON_DISCLOSE',
    OTHER: 'OTHER',
    UNKNOWN: 'UNKNOWN'
};
export var YstNominationStatusValue = {
    ACCEPTED: 'ACCEPTED',
    APPROVED: 'APPROVED',
    DECLINED: 'DECLINED',
    INVITED: 'INVITED',
    INVITE_FAILED: 'INVITE_FAILED',
    INVITE_SCHEDULED: 'INVITE_SCHEDULED',
    PENDING_APPROVAL: 'PENDING_APPROVAL',
    REJECTED: 'REJECTED',
    SUGGESTED: 'SUGGESTED'
};
export var YstPatientMessageValue = {
    ADMIN_CONTACT_RESPONSE: 'ADMIN_CONTACT_RESPONSE',
    CHECKIN_CALL_REMINDER: 'CHECKIN_CALL_REMINDER',
    CHECKIN_END: 'CHECKIN_END',
    CHECKIN_MIDDLE: 'CHECKIN_MIDDLE',
    CHECKIN_REMINDER: 'CHECKIN_REMINDER',
    CHECKIN_START: 'CHECKIN_START',
    GUARDIAN_INVITE: 'GUARDIAN_INVITE',
    INBOUND: 'INBOUND',
    NOMINATION: 'NOMINATION',
    NOMINATION_18PLUS: 'NOMINATION_18PLUS',
    NOMINATION_APPROVED: 'NOMINATION_APPROVED',
    NOMINATION_RESPONSE: 'NOMINATION_RESPONSE',
    NOMINATION_RESPONSE_WITHOUT_SUGGESTION: 'NOMINATION_RESPONSE_WITHOUT_SUGGESTION',
    NOMINATION_SUGGESTION_ACCEPTED: 'NOMINATION_SUGGESTION_ACCEPTED',
    ORIENTATION_REMINDER: 'ORIENTATION_REMINDER',
    RESOURCES_ACTIVATED: 'RESOURCES_ACTIVATED',
    SUPPORTER_ACCEPTED: 'SUPPORTER_ACCEPTED',
    SUPPORTER_CONFIRMATION: 'SUPPORTER_CONFIRMATION',
    SUPPORTER_DECLINED: 'SUPPORTER_DECLINED',
    SUPPORTER_GENERAL_RESOURCES_REMINDER: 'SUPPORTER_GENERAL_RESOURCES_REMINDER',
    SUPPORTER_INVITE: 'SUPPORTER_INVITE',
    SUPPORTER_INVITE_REMINDER: 'SUPPORTER_INVITE_REMINDER',
    YOUTH_INVITE: 'YOUTH_INVITE'
};
// @ts-ignore
import { z } from 'zod';
export var AnySchema = z.unknown();
export var ArtifactIDSchema = z.unknown();
export var AssetIDSchema = z.unknown();
export var DateSchema = z.string().regex(/^(\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01]))$/).transform(function(v) {
    return v;
});
export var DateTimeSchema = z.string().regex(/^(\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])T([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9]|60))(\.\d{1,})?(([Z])|([+|-]([01][0-9]|2[0-3]):[0-5][0-9]))$/);
export var JSONObjectSchema = z.unknown();
export var MapSchema = z.unknown();
export var QuizSetItemQuestionDirectiveFeedbackSchema = z.unknown();
export var QuizSetItemQuestionLabelSchema = z.unknown();
export var UUIDSchema = z.string({
    error: 'Required'
}).uuid({
    message: 'Invalid value'
}).transform(function(v) {
    return v;
});
export var UserIDSchema = z.unknown();
export var YstMentalHealthConcernsSchema = CustomScalars.YstMentalHealthConcerns;
export var YstOnboardingAvailabilitySchema = CustomScalars.YstOnboardingAvailability;
export var YstRecurringAvailabilitySchema = CustomScalars.YstRecurringAvailability;
export var ActionTypeSchema = z.enum([
    "ACTIVITY_ADD",
    "ACTIVITY_RATE",
    "BREATH_HOLDING",
    "COPING_CARD_ADD",
    "COPING_CARD_REVIEW",
    "EATING_LOG_ADD",
    "HOPE_KIT_ADD",
    "HOPE_KIT_REVIEW",
    "HYPERVENTILATION",
    "MY_PLAN_REVIEW",
    "RELAX",
    "SLEEP_DIARY_ENTRY_MORNING",
    "SLEEP_DIARY_ENTRY_NIGHT",
    "STATIC_01",
    "STATIC_02",
    "STATIC_03",
    "STATIC_04",
    "STATIC_05",
    "STATIC_06",
    "STATIC_07",
    "STATIC_08",
    "STATIC_09",
    "STATIC_10",
    "STATIC_11",
    "STATIC_12",
    "THOUGHT_DIARY_SPOT",
    "THOUGHT_DIARY_SWITCH",
    "THOUGHT_DIARY_TEST",
    "WORD_PAIRING"
]);
export var AddressUseSchema = z.enum([
    "HOME",
    "OLD",
    "TEMP",
    "WORK"
]);
export var AppActivityNameSchema = z.enum([
    "ActivityDiary",
    "BingeEatingMyPlan",
    "BreathHolding",
    "CopingCards",
    "CrisisFramework",
    "EatingLog",
    "EditEatingSchedule",
    "HopeKit",
    "Hyperventilation",
    "MyPlanReview",
    "Relaxation",
    "RiskCurve",
    "SleepDiary",
    "SoloMyPlan",
    "SoloRiskCurve",
    "SoloSuicideMode",
    "StressSensitivityAssessment",
    "SuicideMode",
    "ThoughtDiary",
    "WordPairing"
]);
export var CaringContactsMediumSchema = z.enum([
    "EMAIL",
    "MAIL",
    "NONE",
    "SMS"
]);
export var CompositionTemplateSchema = z.enum([
    "BINGE_EATING_MY_PLAN",
    "EATING_COMMITMENT",
    "EATING_SCHEDULE",
    "MYSTORYMYPLAN",
    "MYSTORYMYPLAN_CLINICAL",
    "SCREENER_CSSRS",
    "SCREENER_NUMERIC",
    "STRESS_SENSITIVITY_ASSESSMENT",
    "TEST",
    "YST_MENTAL_HEALTH_CONCERNS"
]);
export var ContactPointSystemSchema = z.enum([
    "EMAIL",
    "FAX",
    "OTHER",
    "PAGER",
    "PHONE",
    "SMS",
    "URL"
]);
export var ContactPointUseSchema = z.enum([
    "HOME",
    "MOBILE",
    "OLD",
    "TEMP",
    "WORK"
]);
export var ContentTypeSchema = z.enum([
    "ACTIVITY_PLANNING",
    "ANXIETY_CAUSES",
    "BODY_IMAGE",
    "BREATH_HOLDING",
    "COPING_CARDS",
    "EATING_THE_RIGHT_FOODS",
    "ENVIRONMENT_SAFETY",
    "EXERCISE_AND_SLEEP",
    "HOPE_KIT",
    "HOW_TO_HELP",
    "HYPERVENTILATION",
    "MOOD_MODULATION",
    "MOOD_TOLERANCE",
    "MYPLAN",
    "MYPLAN_REVIEW",
    "MYSTORYMYPLAN",
    "OVEREATING_CYCLE",
    "POST_AVIVA",
    "REDUCE_RISK",
    "REGULAR_EATING",
    "RELAPSE_PREVENTION",
    "RELAXATION",
    "REMOVING_BARRIERS",
    "REVIEW_PREVENT_PRACTICE",
    "SLEEP",
    "SOCIAL_SUPPORT",
    "SPOT_IT",
    "STATIC_01",
    "STATIC_02",
    "STATIC_03",
    "STATIC_04",
    "STATIC_05",
    "STATIC_06",
    "STATIC_07",
    "STATIC_08",
    "STATIC_09",
    "STATIC_10",
    "STATIC_11",
    "STATIC_12",
    "SWITCH_IT",
    "TEST",
    "TEST_IT",
    "THINK_CLEAR",
    "URGE_SURFING",
    "V1_SESSION_01",
    "V1_SESSION_02",
    "V1_SESSION_03",
    "V1_SESSION_04",
    "V1_SESSION_05",
    "V1_SESSION_06",
    "V1_SESSION_06P",
    "V1_SESSION_07",
    "V1_SESSION_07P",
    "V1_SESSION_08",
    "V1_SESSION_08P",
    "V1_SESSION_09",
    "V1_SESSION_09P",
    "V1_SESSION_10",
    "V1_SESSION_10P",
    "V1_WELCOME",
    "WEIGHT_STIGMA",
    "WORD_PAIRING"
]);
export var CrisisFrameworkSchema = z.enum([
    "RISK_CURVE_TIMELINE",
    "SUICIDE_MODE"
]);
export var EatingCheckinCompletionButtonSchema = z.enum([
    "DONE",
    "SUGGESTION"
]);
export var EatingCheckinTriggerSchema = z.enum([
    "EATING_LOG",
    "SESSION"
]);
export var EatingCommitmentHealthyFoodSchema = z.enum([
    "FRUITS",
    "GRAINS",
    "HEALTHY_FATS",
    "LEAN_MEATS",
    "OTHER",
    "VEGETABLES"
]);
export var EatingCommitmentUnhealthyFoodSchema = z.enum([
    "CANDY",
    "DESSERTS",
    "JUNK_FOOD",
    "OTHER",
    "SODA",
    "TAKEOUT"
]);
export var EatingLogMealTypeSchema = z.enum([
    "BREAKFAST",
    "DINNER",
    "LUNCH",
    "SNACK"
]);
export var EatingProgressWeightUnitSchema = z.enum([
    "KG",
    "LBS"
]);
export var EntityTypeSchema = z.enum([
    "GQL_MUTATION",
    "GQL_QUERY",
    "ORGANIZATION",
    "ORGANIZATION_PRODUCT",
    "ROLE",
    "USER"
]);
export var FileUploadTypeSchema = z.enum([
    "APP_LOGO",
    "CHAT_IMAGE",
    "ILLUSTRATION",
    "QUIZ_SET_VIDEO",
    "VIDEO",
    "VIDEO_TEXT_TRACK"
]);
export var JobStatusSchema = z.enum([
    "CREATED",
    "ERROR",
    "QUEUED",
    "RUNNING",
    "SUCCESS"
]);
export var JobTypeSchema = z.enum([
    "AMPLITUDE_IMPORT",
    "CHANGEBITE_NOTIFICATIONS",
    "CHECK_EXPO_PUSH_RECEIPTS",
    "DETOX_USER_CLEANUP",
    "EMAIL_USERS",
    "ENQUEUE_JOBS",
    "EXPIRED_USER_SESSION_CLEANUP",
    "GROUP_SESSIONS",
    "INVITE_YST_NOMINEE",
    "LOG",
    "MEAL_REMINDER",
    "MY_PLAN_UPDATED_SUPPORTER_NOTIFICATION",
    "NORMALIZE_AMPLITUDE_EVENT_SESSION_START",
    "NORMALIZE_USERS_PHONE",
    "OTX202_DATA_EXPORT",
    "PATIENTS_PROGRESS_STARTED_AT_FOR_PRODUCT_STATIC_BACKFILL",
    "PATIENT_CARING_CONTACTS",
    "PATIENT_NOTIFICATIONS",
    "PATIENT_SPOOL",
    "PROCESS_VIDEO_ASSET",
    "PTSD_NOTIFICATIONS",
    "SEND_EMAIL",
    "SLEEP",
    "SYNC_GCS_MEDIA_UPLOAD",
    "TEST_RECORD_CLEANUP",
    "UNLOCK_SESSIONS",
    "YST_NEW_SIGNUP_EMAIL",
    "YST_NOMINATION_REMINDER",
    "YST_REPORTS",
    "YST_SUPPORTER"
]);
export var LegacyUserGenderSchema = z.enum([
    "FEMALE",
    "MALE",
    "NOANSWER",
    "OTHER"
]);
export var LegacyUserRaceSchema = z.enum([
    "ASIAN",
    "BLACK",
    "NATIVE",
    "NOANSWER",
    "OTHER",
    "PACIFIC",
    "WHITE"
]);
export var LegacyUserSexualitySchema = z.enum([
    "BISEXUAL",
    "HETEROSEXUAL",
    "HOMOSEXUAL",
    "NOANSWER"
]);
export var MediaActionSchema = z.enum([
    "FILE_UPLOAD_TO_GCS",
    "MUX_HOSTING",
    "REV_CAPTIONING"
]);
export var MuxFitModeSchema = z.enum([
    "crop",
    "pad",
    "preserve",
    "smartcrop"
]);
export var OnboardingVariantSchema = z.enum([
    "COLLABORATIVE",
    "INDEPENDENT"
]);
export var OuiUserRoleTypeSchema = z.enum([
    "OUI_ADMIN",
    "PATIENT",
    "PRACTITIONER",
    "REGISTRAR",
    "UNKNOWN"
]);
export var PatientGenderIdentitySchema = z.enum([
    "FEMALE",
    "MALE",
    "NON_BINARY",
    "NON_DISCLOSE",
    "TRANSGENDER_FEMALE",
    "TRANSGENDER_MALE",
    "UNKNOWN"
]);
export var PatientMilitaryStatusSchema = z.enum([
    "ACTIVE_MILITARY_DUTY",
    "CIVILIAN",
    "DISABLED_VETERAN",
    "FAMILY_MEMBER_OF_ACTIVE_DUTY",
    "FAMILY_MEMBER_OF_RETIRED_MILITARY",
    "INACTIVE_READY_RESERVE",
    "NATIONAL_GUARD",
    "NON_DISCLOSE",
    "RESERVES",
    "RETIRED_MILITARY",
    "UNKNOWN",
    "VETERAN"
]);
export var PatientRaceSchema = z.enum([
    "AMERICAN_INDIAN_OR_ALASKA_NATIVE",
    "ASIAN",
    "BLACK_OR_AFRICAN_AMERICAN",
    "NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER",
    "NON_DISCLOSE",
    "UNKNOWN",
    "WHITE"
]);
export var PatientSexualOrientationSchema = z.enum([
    "BISEXUAL",
    "HETEROSEXUAL",
    "HOMOSEXUAL",
    "NON_DISCLOSE",
    "OTHER",
    "UNKNOWN"
]);
export var PatientSupporterRelationSchema = z.enum([
    "CLINICIAN",
    "OTHER",
    "PARENT_GUARDIAN",
    "RELATIVE",
    "SOCIAL_SERVICES"
]);
export var PracticeTypeSchema = z.enum([
    "ACTIVITY",
    "BREATH_HOLDING",
    "EATING_CHECKIN",
    "EATING_COMMITMENT_ENTRY",
    "EATING_LOG_ENTRY",
    "EATING_PROGRESS_ENTRY",
    "HYPERVENTILATION",
    "RELAX_DIARY_ENTRY",
    "SLEEP_DIARY_ENTRY",
    "THOUGHT_DIARY_ENTRY",
    "WORD_PAIRING"
]);
export var ProductVariantSchema = z.enum([
    "AVIVA_ADOLESCENT",
    "AVIVA_ADULT",
    "AVIVA_INPATIENT",
    "AVIVA_MILITARY",
    "AVIVA_STATIC",
    "AVIVA_SUPPORT",
    "OUI_PLATFORM",
    "YST_GUARDIAN",
    "YST_SUPPORT",
    "YST_YOUTH"
]);
export var ProductVersionSchema = z.enum([
    "AVIVA_1_1",
    "AVIVA_2_0"
]);
export var PtsdDosageVersionSchema = z.enum([
    "V1",
    "V2"
]);
export var QuizSetItemTypeSchema = z.enum([
    "MULTIPLE_CHOICE",
    "SINGLE_CHOICE",
    "VIDEO"
]);
export var RatingDurationSchema = z.enum([
    "ALL",
    "DAY",
    "MONTH",
    "WEEK",
    "YEAR"
]);
export var RatingTypeSchema = z.enum([
    "QUALITY",
    "RATING",
    "RATING_AFTER",
    "RATING_BEFORE"
]);
export var RoleTypeSchema = z.enum([
    "GUARDIAN",
    "PATIENT",
    "PRACTITIONER",
    "REGISTRAR",
    "SUPPORTER"
]);
export var SessionStateSchema = z.enum([
    "COMPLETED",
    "IN_PROGRESS",
    "LOCKED",
    "UNLOCKED"
]);
export var SleepDiaryEntryDurationSchema = z.enum([
    "DURATION_1_TO_5",
    "DURATION_5_TO_10",
    "DURATION_15_TO_30",
    "DURATION_20_TO_45",
    "DURATION_30_TO_60",
    "DURATION_45_TO_60",
    "DURATION_60_TO_120",
    "DURATION_120_TO_180",
    "DURATION_LESS_THAN_15",
    "DURATION_MORE_THAN_60",
    "DURATION_MORE_THAN_120",
    "DURATION_MORE_THAN_180"
]);
export var SleepDiaryEntryTimeOfDaySchema = z.enum([
    "AFTERNOON",
    "EVENING",
    "MORNING",
    "NIGHT"
]);
export var UploadTypeSchema = z.enum([
    "AUDIO",
    "IMAGE",
    "VIDEO"
]);
export var UsageDurationSchema = z.enum([
    "DAY",
    "MONTH",
    "WEEK"
]);
export var UserGenderIdentitySchema = z.enum([
    "FEMALE",
    "MALE",
    "NON_BINARY",
    "NON_DISCLOSE",
    "TRANSGENDER_FEMALE",
    "TRANSGENDER_MALE",
    "UNKNOWN"
]);
export var UserMilitaryStatusSchema = z.enum([
    "ACTIVE_MILITARY_DUTY",
    "CIVILIAN",
    "DISABLED_VETERAN",
    "FAMILY_MEMBER_OF_ACTIVE_DUTY",
    "FAMILY_MEMBER_OF_RETIRED_MILITARY",
    "INACTIVE_READY_RESERVE",
    "NATIONAL_GUARD",
    "NON_DISCLOSE",
    "RESERVES",
    "RETIRED_MILITARY",
    "UNKNOWN",
    "VETERAN"
]);
export var UserRaceSchema = z.enum([
    "AMERICAN_INDIAN_OR_ALASKA_NATIVE",
    "ASIAN",
    "BLACK_OR_AFRICAN_AMERICAN",
    "NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER",
    "NON_DISCLOSE",
    "UNKNOWN",
    "WHITE"
]);
export var UserSexualOrientationSchema = z.enum([
    "BISEXUAL",
    "HETEROSEXUAL",
    "HOMOSEXUAL",
    "NON_DISCLOSE",
    "OTHER",
    "UNKNOWN"
]);
export var YstNominationStatusValueSchema = z.enum([
    "ACCEPTED",
    "APPROVED",
    "DECLINED",
    "INVITED",
    "INVITE_FAILED",
    "INVITE_SCHEDULED",
    "PENDING_APPROVAL",
    "REJECTED",
    "SUGGESTED"
]);
export var YstPatientMessageValueSchema = z.enum([
    "ADMIN_CONTACT_RESPONSE",
    "CHECKIN_CALL_REMINDER",
    "CHECKIN_END",
    "CHECKIN_MIDDLE",
    "CHECKIN_REMINDER",
    "CHECKIN_START",
    "GUARDIAN_INVITE",
    "INBOUND",
    "NOMINATION",
    "NOMINATION_18PLUS",
    "NOMINATION_APPROVED",
    "NOMINATION_RESPONSE",
    "NOMINATION_RESPONSE_WITHOUT_SUGGESTION",
    "NOMINATION_SUGGESTION_ACCEPTED",
    "ORIENTATION_REMINDER",
    "RESOURCES_ACTIVATED",
    "SUPPORTER_ACCEPTED",
    "SUPPORTER_CONFIRMATION",
    "SUPPORTER_DECLINED",
    "SUPPORTER_GENERAL_RESOURCES_REMINDER",
    "SUPPORTER_INVITE",
    "SUPPORTER_INVITE_REMINDER",
    "YOUTH_INVITE"
]);
export var ActionValuesInputSchema = z.lazy(function() {
    return z.object({
        patientID: UUIDSchema
    });
});
export var ActivityInputSchema = z.lazy(function() {
    return z.object({
        attendee: z.string().nullish(),
        endTime: DateTimeSchema,
        location: z.string().nullish(),
        notes: z.string().nullish(),
        startTime: DateTimeSchema,
        title: z.string()
    });
});
export var AddActionInputSchema = z.lazy(function() {
    return z.object({
        actionType: ActionTypeSchema,
        actionValues: ActionValuesInputSchema,
        practiceID: UUIDSchema.nullish()
    });
});
export var AddActivityPracticeInputSchema = z.lazy(function() {
    return z.object({
        activity: ActivityInputSchema,
        practiceValues: PracticeValuesInputSchema
    });
});
export var AddEatingLogEntryInputSchema = z.lazy(function() {
    return z.object({
        eatingLogEntry: EatingLogEntryInputSchema,
        practiceValues: PracticeValuesInputSchema
    });
});
export var AddHopeKitImageInputSchema = z.lazy(function() {
    return z.object({
        hopeKitImage: HopeKitImageInputSchema,
        uploadContentType: z.string()
    });
});
export var AddHopeKitQuoteInputSchema = z.lazy(function() {
    return z.object({
        hopeKitQuote: HopeKitQuoteInputSchema
    });
});
export var AddHopeKitVideoInputSchema = z.lazy(function() {
    return z.object({
        hopeKitVideo: HopeKitVideoInputSchema,
        uploadContentType: z.string()
    });
});
export var AddRelaxDiaryEntryPracticeInputSchema = z.lazy(function() {
    return z.object({
        practiceValues: PracticeValuesInputSchema,
        relaxDiaryEntry: RelaxDiaryEntryInputSchema
    });
});
export var AddSleepDiaryEntryPracticeInputSchema = z.lazy(function() {
    return z.object({
        practiceValues: PracticeValuesInputSchema,
        sleepDiaryEntry: SleepDiaryEntryInputSchema
    });
});
export var AddThoughtDiaryEntryPracticeInputSchema = z.lazy(function() {
    return z.object({
        practiceValues: PracticeValuesInputSchema,
        thoughtDiaryEntry: ThoughtDiaryEntryInputSchema
    });
});
export var AddressInputSchema = z.lazy(function() {
    return z.object({
        city: z.string().nullish(),
        line: z.array(z.string()).nullish(),
        postalCode: z.string().nullish(),
        rank: z.number(),
        state: z.string().nullish(),
        use: AddressUseSchema
    });
});
export var BreathHoldingWidgetStressBreathingExercisesInputSchema = z.lazy(function() {
    return z.object({
        after: DateSchema.nullish(),
        before: DateSchema.nullish(),
        limit: z.number().nullish()
    });
});
export var CMSAppCreateInputSchema = z.lazy(function() {
    return z.object({
        logoID: UUIDSchema,
        name: z.string()
    });
});
export var CMSAppUpdateInputSchema = z.lazy(function() {
    return z.object({
        appID: UUIDSchema,
        logoID: UUIDSchema.nullish(),
        name: z.string().nullish()
    });
});
export var CMSSessionCreateInputSchema = z.lazy(function() {
    return z.object({
        agenda: z.array(z.string()).nullish(),
        completedIllustrationID: UUIDSchema.nullish(),
        content: JSONObjectSchema.nullish(),
        contentType: z.string(),
        description: z.string(),
        groupID: UUIDSchema,
        illustrationID: UUIDSchema.nullish(),
        locale: z.string(),
        name: z.string(),
        order: z.number(),
        variantID: UUIDSchema
    });
});
export var CMSSessionGroupCreateInputSchema = z.lazy(function() {
    return z.object({
        name: z.string(),
        order: z.number().nullish(),
        variantID: UUIDSchema
    });
});
export var CMSSessionGroupUpdateInputSchema = z.lazy(function() {
    return z.object({
        groupID: UUIDSchema,
        name: z.string(),
        order: z.number()
    });
});
export var CMSVariantCreateInputSchema = z.lazy(function() {
    return z.object({
        appID: UUIDSchema,
        name: z.string(),
        version: z.string()
    });
});
export var CMSVariantUpdateInputSchema = z.lazy(function() {
    return z.object({
        appID: UUIDSchema.nullish(),
        name: z.string().nullish(),
        variantID: UUIDSchema,
        version: z.string().nullish()
    });
});
export var ChangeBiteRoleSettingsInputSchema = z.lazy(function() {
    return z.object({
        sessionUnlockDayOfWeek: z.number().nullish()
    });
});
export var CompleteQuizSetForPatientInputSchema = z.lazy(function() {
    return z.object({
        patientID: UUIDSchema,
        quizSetID: z.string(),
        slug: z.string()
    });
});
export var CompletedQuizSetsForPatientInputSchema = z.lazy(function() {
    return z.object({
        patientID: UUIDSchema,
        slug: z.string()
    });
});
export var ContactPointInputSchema = z.lazy(function() {
    return z.object({
        rank: z.number(),
        system: ContactPointSystemSchema,
        use: ContactPointUseSchema,
        value: z.string()
    });
});
export var CopyQuizSetToCollectionInputSchema = z.lazy(function() {
    return z.object({
        quizSetCollectionID: UUIDSchema,
        quizSetID: UUIDSchema
    });
});
export var CopySessionInputSchema = z.lazy(function() {
    return z.object({
        destination: CopySessionInputDestinationSchema,
        sessionID: UUIDSchema
    });
});
export var CopySessionInputDestinationSchema = z.lazy(function() {
    return z.object({
        groupID: UUIDSchema,
        variantID: UUIDSchema
    });
});
export var CreateRoleInputSchema = z.lazy(function() {
    return z.object({
        organizationID: UUIDSchema,
        practitioners: z.array(RolePractitionerInputSchema).nullish(),
        productConfig: RoleProductConfigInputSchema.nullish(),
        productID: UUIDSchema,
        productStatic: z.boolean(),
        roleType: RoleTypeSchema,
        supporteeID: UUIDSchema.nullish(),
        supporteeRelation: PatientSupporterRelationSchema.nullish()
    });
});
export var CreateUserInputSchema = z.lazy(function() {
    return z.object({
        addresses: z.array(AddressInputSchema).nullish(),
        birthDate: DateSchema.nullish(),
        email: z.string().email(),
        familyName: z.string().nullish(),
        genderIdentity: UserGenderIdentitySchema.nullish(),
        givenName: z.string().nullish(),
        locale: z.string().nullish(),
        militaryStatus: UserMilitaryStatusSchema.nullish(),
        phone: z.string().nullish(),
        race: UserRaceSchema.nullish(),
        settings: UserSettingsInputSchema.nullish(),
        sexualOrientation: UserSexualOrientationSchema.nullish(),
        timezone: z.string().nullish()
    });
});
export var DeleteRoleInputSchema = z.lazy(function() {
    return z.object({
        roleID: UUIDSchema
    });
});
export var DeleteSessionGroupInputSchema = z.lazy(function() {
    return z.object({
        groupID: UUIDSchema
    });
});
export var DeleteSessionInputSchema = z.lazy(function() {
    return z.object({
        sessionID: UUIDSchema
    });
});
export var DeviceInputSchema = z.lazy(function() {
    return z.object({
        expoToken: z.string().nullish(),
        installationID: UUIDSchema,
        platform: z.string(),
        pushToken: z.string().nullish()
    });
});
export var EatingCheckinInputSchema = z.lazy(function() {
    return z.object({
        completionButtonClicked: EatingCheckinCompletionButtonSchema.nullish(),
        completionTimestamp: DateTimeSchema.nullish(),
        mood: z.number().nullish(),
        promptTimestamp: DateTimeSchema,
        trigger: EatingCheckinTriggerSchema,
        urgeLevel: z.number().nullish()
    });
});
export var EatingCommitmentEntryInputSchema = z.lazy(function() {
    return z.object({
        decreaseCommitment: EatingCommitmentUnhealthyFoodSchema,
        decreaseSuccess: z.boolean().nullish(),
        increaseCommitment: EatingCommitmentHealthyFoodSchema,
        increaseSuccess: z.boolean().nullish()
    });
});
export var EatingLogEntryInputSchema = z.lazy(function() {
    return z.object({
        binged: z.boolean(),
        description: z.string().nullish(),
        meal: EatingLogMealTypeSchema,
        timestamp: DateTimeSchema
    });
});
export var EatingLogEntryPracticeImageUploadUrlInputSchema = z.lazy(function() {
    return z.object({
        contentType: z.string()
    });
});
export var EatingProgressEntryInputSchema = z.lazy(function() {
    return z.object({
        binges: z.number().nullish(),
        fadFixes: z.number().nullish(),
        timestamp: DateTimeSchema,
        weight: z.number().nullish(),
        weightUnit: EatingProgressWeightUnitSchema.nullish()
    });
});
export var EntityAccessLogRequestInputSchema = z.lazy(function() {
    return z.object({
        entityID: UUIDSchema,
        entityType: EntityTypeSchema
    });
});
export var ExchangePatchInputSchema = z.lazy(function() {
    return z.object({
        exchangeID: UUIDSchema,
        patches: z.array(PatchInputSchema)
    });
});
export var FileUploadActionCompleteInputSchema = z.lazy(function() {
    return z.object({
        fileUploadId: UUIDSchema,
        mediaAction: MediaActionSchema
    });
});
export var FileUploadCreateInputSchema = z.lazy(function() {
    return z.object({
        fileName: z.string(),
        fileUploadType: FileUploadTypeSchema
    });
});
export var HopeKitImageInputSchema = z.lazy(function() {
    return z.object({
        reason: z.string().nullish()
    });
});
export var HopeKitQuoteInputSchema = z.lazy(function() {
    return z.object({
        author: z.string().nullish(),
        reason: z.string().nullish(),
        text: z.string()
    });
});
export var HopeKitVideoInputSchema = z.lazy(function() {
    return z.object({
        reason: z.string().nullish()
    });
});
export var HyperventilationWidgetStressBreathingExercisesInputSchema = z.lazy(function() {
    return z.object({
        after: DateSchema.nullish(),
        before: DateSchema.nullish(),
        limit: z.number().nullish()
    });
});
export var LatLngInputSchema = z.lazy(function() {
    return z.object({
        lat: z.number(),
        lng: z.number()
    });
});
export var MutationAddBreathHoldingPracticeInputSchema = z.lazy(function() {
    return z.object({
        practiceValues: PracticeValuesInputSchema,
        stressBreathingExercise: StressBreathingExerciseInputSchema
    });
});
export var MutationAddEatingCheckinInputSchema = z.lazy(function() {
    return z.object({
        eatingCheckin: EatingCheckinInputSchema,
        practiceValues: PracticeValuesInputSchema
    });
});
export var MutationAddEatingProgressEntryInputSchema = z.lazy(function() {
    return z.object({
        eatingProgressEntry: EatingProgressEntryInputSchema,
        practiceValues: PracticeValuesInputSchema
    });
});
export var MutationAddHyperventilationPracticeInputSchema = z.lazy(function() {
    return z.object({
        practiceValues: PracticeValuesInputSchema,
        stressBreathingExercise: StressBreathingExerciseInputSchema
    });
});
export var MutationAddWordPairingPracticeInputSchema = z.lazy(function() {
    return z.object({
        practiceValues: PracticeValuesInputSchema,
        wordPairing: WordPairingInputSchema
    });
});
export var MutationAddYstSupporterEventInputSchema = z.lazy(function() {
    return z.object({
        patientID: UUIDSchema,
        status: z.string(),
        type: z.string(),
        value: z.string(),
        youthID: UUIDSchema
    });
});
export var MutationContactYstSupportInputSchema = z.lazy(function() {
    return z.object({
        body: z.string(),
        primaryClinician: z.boolean().nullish()
    });
});
export var MutationCreateJobInputSchema = z.lazy(function() {
    return z.object({
        payload: JSONObjectSchema,
        synchronous: z.boolean().nullish(),
        type: JobTypeSchema
    });
});
export var MutationCreateTestScenarioInputSchema = z.lazy(function() {
    return z.object({
        organization: OrganizationInputSchema,
        users: z.array(TestUserInputSchema)
    });
});
export var MutationCreateUserInputSchema = z.lazy(function() {
    return z.object({
        roles: z.array(CreateRoleInputSchema),
        user: CreateUserInputSchema
    });
});
export var MutationCreateVideoInputSchema = z.lazy(function() {
    return z.object({
        fileUploadID: UUIDSchema
    });
});
export var MutationDeclineYstNominationInputSchema = z.lazy(function() {
    return z.object({
        reason: z.string()
    });
});
export var MutationInviteYSTGuardianInputSchema = z.lazy(function() {
    return z.object({
        guardian: YSTPatientInputSchema,
        youthID: UUIDSchema
    });
});
export var MutationInviteYSTYouthInputSchema = z.lazy(function() {
    return z.object({
        youth: YSTPatientInputSchema
    });
});
export var MutationNominateYstSupportersInputSchema = z.lazy(function() {
    return z.object({
        create: z.array(YstNominationCreateInputSchema).nullish(),
        reject: z.array(YstNominationRejectInputSchema).nullish(),
        update: z.array(YstNominationUpdateInputSchema).nullish(),
        youthID: UUIDSchema
    });
});
export var MutationPersistBotStateInputSchema = z.lazy(function() {
    return z.object({
        configID: z.string(),
        envelopes: z.array(MapSchema),
        previousBotStateID: UUIDSchema.nullish(),
        state: z.string()
    });
});
export var MutationPreviewYstPatientMessageInputSchema = z.lazy(function() {
    return z.object({
        ystPatientMessageID: UUIDSchema
    });
});
export var MutationRateYstSupporterCheckinInputSchema = z.lazy(function() {
    return z.object({
        rating: z.number().int().min(1).max(6),
        ystSupporterCheckinID: UUIDSchema
    });
});
export var MutationResendYstPatientMessageInputSchema = z.lazy(function() {
    return z.object({
        ystPatientMessageID: UUIDSchema
    });
});
export var MutationSignupYSTGuardianInputSchema = z.lazy(function() {
    return z.object({
        organizationID: UUIDSchema,
        password: z.string().min(8),
        patient: YSTPatientInputSchema
    });
});
export var MutationSignupYSTYouthInputSchema = z.lazy(function() {
    return z.object({
        organizationID: UUIDSchema,
        password: z.string().min(8),
        patient: YSTPatientInputSchema
    });
});
export var MutationUpdateBreathHoldingPracticeInputSchema = z.lazy(function() {
    return z.object({
        practiceID: UUIDSchema,
        practiceValues: PracticeValuesInputSchema,
        stressBreathingExercise: StressBreathingExerciseInputSchema
    });
});
export var MutationUpdateEatingCheckinInputSchema = z.lazy(function() {
    return z.object({
        eatingCheckin: EatingCheckinInputSchema,
        practiceID: UUIDSchema,
        practiceValues: PracticeValuesInputSchema
    });
});
export var MutationUpdateEatingProgressEntryInputSchema = z.lazy(function() {
    return z.object({
        eatingProgressEntry: EatingProgressEntryInputSchema,
        practiceID: UUIDSchema,
        practiceValues: PracticeValuesInputSchema
    });
});
export var MutationUpdateFirstCheckinDateInputSchema = z.lazy(function() {
    return z.object({
        date: DateSchema,
        patientID: UUIDSchema
    });
});
export var MutationUpdateHyperventilationPracticeInputSchema = z.lazy(function() {
    return z.object({
        practiceID: UUIDSchema,
        practiceValues: PracticeValuesInputSchema,
        stressBreathingExercise: StressBreathingExerciseInputSchema
    });
});
export var MutationUpdateOnboardingAvailabilityInputSchema = z.lazy(function() {
    return z.object({
        onboardingAvailability: YstOnboardingAvailabilitySchema
    });
});
export var MutationUpdatePracticeInputSchema = z.lazy(function() {
    return z.object({
        content: PracticeContentInputSchema.nullish(),
        date: DateSchema.nullish(),
        practiceID: UUIDSchema,
        ratings: z.array(PracticeRatingInputSchema).nullish()
    });
});
export var MutationUpdateRecurringAvailabilityInputSchema = z.lazy(function() {
    return z.object({
        patientID: UUIDSchema.nullish(),
        recurringAvailability: YstRecurringAvailabilitySchema
    });
});
export var MutationUpdateRoleSettingsInputSchema = z.lazy(function() {
    return z.object({
        roleID: UUIDSchema,
        settings: RoleSettingsInputSchema
    });
});
export var MutationUpdateUserInputSchema = z.lazy(function() {
    return z.object({
        roles: z.array(RoleInputSchema).nullish(),
        user: UpdateUserInputSchema.nullish(),
        userID: UUIDSchema
    });
});
export var MutationUpdateWordPairingPracticeInputSchema = z.lazy(function() {
    return z.object({
        practiceID: UUIDSchema,
        practiceValues: PracticeValuesInputSchema,
        wordPairing: WordPairingInputSchema
    });
});
export var MutationUpdateYstMentalHealthConcernsInputSchema = z.lazy(function() {
    return z.object({
        patientID: UUIDSchema,
        ystMentalHealthConcerns: YstMentalHealthConcernsSchema
    });
});
export var MutationUpdateYstSupporterEventInputSchema = z.lazy(function() {
    return z.object({
        status: z.string(),
        type: z.string(),
        value: z.string(),
        ystSupporterEventID: UUIDSchema
    });
});
export var OrganizationAvivaConfigInputSchema = z.lazy(function() {
    return z.object({
        caringContactsEnabled: z.boolean(),
        crisisFramework: CrisisFrameworkSchema,
        onboardingVariant: OnboardingVariantSchema,
        productVersion: ProductVersionSchema
    }).merge(z.object({
        "caringContactsEnabled": z.boolean(),
        "crisisFramework": z.enum([
            "SUICIDE_MODE",
            "RISK_CURVE_TIMELINE"
        ]),
        "onboardingVariant": z.enum([
            "COLLABORATIVE",
            "INDEPENDENT"
        ]),
        "productVersion": z.enum([
            "AVIVA_1_1",
            "AVIVA_2_0"
        ])
    }));
});
export var OrganizationInputSchema = z.lazy(function() {
    return z.object({
        isTrialOrganization: z.boolean().nullish(),
        logoUrl: z.string().nullish(),
        name: z.string(),
        parent: UUIDSchema.nullish(),
        products: z.array(OrganizationProductInputSchema).nullish()
    });
});
export var OrganizationMemberUpdateInputSchema = z.lazy(function() {
    return z.object({
        person: PersonUpdateInputSchema.nullish(),
        roles: z.array(OuiUserRoleTypeSchema)
    });
});
export var OrganizationProductConfigInputSchema = z.lazy(function() {
    return z.object({
        avivaConfig: OrganizationAvivaConfigInputSchema.nullish(),
        ystConfig: OrganizationYstConfigInputSchema.nullish()
    });
});
export var OrganizationProductInputSchema = z.lazy(function() {
    return z.object({
        name: z.string().nullish(),
        nameStatic: z.string().nullish(),
        productConfig: OrganizationProductConfigInputSchema.nullish(),
        productID: UUIDSchema
    });
});
export var OrganizationUpdateInputSchema = z.lazy(function() {
    return z.object({
        isTrialOrganization: z.boolean().nullish(),
        logoUrl: z.string().nullish(),
        name: z.string().nullish(),
        products: z.array(OrganizationProductInputSchema).nullish()
    });
});
export var OrganizationYstConfigHomepageQuoteInputSchema = z.lazy(function() {
    return z.object({
        author: z.string(),
        photoUrl: z.string(),
        quote: z.string()
    }).merge(z.object({
        "author": z.string(),
        "quote": z.string(),
        "photoUrl": z.string().url()
    }));
});
export var OrganizationYstConfigInputSchema = z.lazy(function() {
    return z.object({
        contacts: z.array(z.string()),
        homepageQuotes: z.array(OrganizationYstConfigHomepageQuoteInputSchema).nullish(),
        slug: z.string(),
        unlisted: z.boolean().nullish()
    }).merge(z.object({
        "slug": z.string().regex(new RegExp("^[\\w-]+$"), "Can only contain letters and dashes"),
        "contacts": z.array(z.string().email().regex(new RegExp("^(?:[A-Za-z0-9_'+\\-]+\\.)*[A-Za-z0-9_'+\\-]*[A-Za-z0-9_+-]@(?:[A-Za-z0-9][A-Za-z0-9\\-]*\\.)+[A-Za-z]{2,}$"))).min(1, "At least one contact email must be provided"),
        "unlisted": z.boolean().default(false),
        "homepageQuotes": z.array(z.object({
            "author": z.string(),
            "quote": z.string(),
            "photoUrl": z.string().url()
        })).describe("Homepage quotes, or undefined for default quotes").optional()
    }));
});
export var PatchInputSchema = z.lazy(function() {
    return z.object({
        inverse: JSONObjectSchema,
        payload: JSONObjectSchema
    });
});
export var PatientInputSchema = z.lazy(function() {
    return z.object({
        caringContactsMedium: CaringContactsMediumSchema.nullish(),
        onboardingVariant: OnboardingVariantSchema.nullish(),
        person: PersonInputSchema,
        productID: UUIDSchema.nullish(),
        productStatic: z.boolean().nullish(),
        productVersion: ProductVersionSchema.nullish(),
        roleType: RoleTypeSchema.nullish()
    });
});
export var PatientSupporterInputSchema = z.lazy(function() {
    return z.object({
        person: PersonInputSchema,
        productStatic: z.boolean().nullish(),
        productVariant: ProductVariantSchema.nullish(),
        relation: PatientSupporterRelationSchema
    });
});
export var PatientSupporterRelationInputSchema = z.lazy(function() {
    return z.object({
        patientID: UUIDSchema,
        relation: PatientSupporterRelationSchema
    });
});
export var PatientUpdateInputSchema = z.lazy(function() {
    return z.object({
        caringContactsMedium: CaringContactsMediumSchema.nullish(),
        person: PersonUpdateInputSchema.nullish()
    });
});
export var PersonInputSchema = z.lazy(function() {
    return z.object({
        birthDate: DateSchema.nullish(),
        email: z.string().email().nullish(),
        familyName: z.string(),
        genderIdentity: UserGenderIdentitySchema.nullish(),
        givenName: z.string(),
        militaryStatus: UserMilitaryStatusSchema.nullish(),
        phone: z.string().nullish(),
        race: UserRaceSchema.nullish(),
        settings: UserSettingsInputSchema.nullish(),
        sexualOrientation: UserSexualOrientationSchema.nullish()
    });
});
export var PersonUpdateInputSchema = z.lazy(function() {
    return z.object({
        birthDate: DateSchema.nullish(),
        contactPoint: z.array(ContactPointInputSchema).nullish(),
        email: z.string().email().nullish(),
        familyName: z.string().nullish(),
        genderIdentity: UserGenderIdentitySchema.nullish(),
        givenName: z.string().nullish(),
        militaryStatus: UserMilitaryStatusSchema.nullish(),
        phone: z.string().nullish(),
        race: UserRaceSchema.nullish(),
        settings: UserSettingsInputSchema.nullish(),
        sexualOrientation: UserSexualOrientationSchema.nullish()
    });
});
export var PersonWithEmailInputSchema = z.lazy(function() {
    return z.object({
        birthDate: DateSchema.nullish(),
        email: z.string().email(),
        familyName: z.string(),
        genderIdentity: UserGenderIdentitySchema.nullish(),
        givenName: z.string(),
        militaryStatus: UserMilitaryStatusSchema.nullish(),
        phone: z.string().nullish(),
        race: UserRaceSchema.nullish(),
        settings: UserSettingsInputSchema.nullish(),
        sexualOrientation: UserSexualOrientationSchema.nullish()
    });
});
export var PracticeContentInputSchema = z.lazy(function() {
    return z.object({
        eatingCommitmentEntry: EatingCommitmentEntryInputSchema
    });
});
export var PracticeRatingInputSchema = z.lazy(function() {
    return z.object({
        type: RatingTypeSchema,
        value: z.number()
    });
});
export var PracticeValuesInputSchema = z.lazy(function() {
    return z.object({
        date: DateSchema.nullish(),
        patientID: UUIDSchema,
        ratings: z.array(PracticeRatingInputSchema)
    });
});
export var PractitionerInputSchema = z.lazy(function() {
    return z.object({
        npi: z.number().nullish(),
        person: PersonInputSchema
    });
});
export var QueryUsersInputSchema = z.lazy(function() {
    return z.object({
        organizationID: UUIDSchema.nullish(),
        primaryPractitionerIDs: z.array(UUIDSchema).nullish(),
        productID: UUIDSchema.nullish(),
        query: z.string().nullish(),
        roleTypes: z.array(RoleTypeSchema).nullish(),
        sessions: z.array(ContentTypeSchema).nullish()
    });
});
export var QuizSetCollectionCreateInputSchema = z.lazy(function() {
    return z.object({
        name: z.string(),
        nodeID: UUIDSchema,
        quizSetCollectionID: UUIDSchema,
        sessionID: UUIDSchema
    });
});
export var QuizSetCollectionUpdateInputSchema = z.lazy(function() {
    return z.object({
        name: z.string(),
        quizSetCollectionID: z.string()
    });
});
export var QuizSetCreateInputSchema = z.lazy(function() {
    return z.object({
        quizSet: QuizSetInputSchema,
        quizSetCollectionID: UUIDSchema
    });
});
export var QuizSetDeleteInputSchema = z.lazy(function() {
    return z.object({
        quizSetID: UUIDSchema
    });
});
export var QuizSetInputSchema = z.lazy(function() {
    return z.object({
        description: z.string(),
        name: z.string()
    });
});
export var QuizSetItemChoiceCreateInputSchema = z.lazy(function() {
    return z.object({
        quizSetID: UUIDSchema,
        quizSetItemChoice: QuizSetItemChoiceInputSchema
    });
});
export var QuizSetItemChoiceInputSchema = z.lazy(function() {
    return z.object({
        afterAllFeedback: z.string(),
        correctFeedback: z.string(),
        incorrectFeedback: z.string(),
        options: z.array(QuizSetItemChoiceOptionInputSchema),
        prompt: z.string(),
        type: QuizSetItemTypeSchema
    });
});
export var QuizSetItemChoiceOptionInputSchema = z.lazy(function() {
    return z.object({
        correct: z.boolean(),
        feedback: z.string(),
        text: z.string(),
        value: z.string()
    });
});
export var QuizSetItemChoiceUpdateInputSchema = z.lazy(function() {
    return z.object({
        quizSetItemChoice: QuizSetItemChoiceInputSchema,
        quizSetItemID: UUIDSchema
    });
});
export var QuizSetItemDeleteInputSchema = z.lazy(function() {
    return z.object({
        quizSetItemID: UUIDSchema
    });
});
export var QuizSetItemUpdateOrderInputSchema = z.lazy(function() {
    return z.object({
        order: z.number(),
        quizSetItemID: UUIDSchema
    });
});
export var QuizSetItemVideoCreateInputSchema = z.lazy(function() {
    return z.object({
        quizSetID: UUIDSchema,
        quizSetItemVideo: QuizSetItemVideoInputSchema
    });
});
export var QuizSetItemVideoInputSchema = z.lazy(function() {
    return z.object({
        fileUploadID: z.string()
    });
});
export var QuizSetUpdateInputSchema = z.lazy(function() {
    return z.object({
        quizSet: QuizSetInputSchema,
        quizSetID: UUIDSchema
    });
});
export var RelaxDiaryEntryInputSchema = z.lazy(function() {
    return z.object({
        completion: z.number(),
        slug: z.string()
    });
});
export var RemoveHopeKitItemInputSchema = z.lazy(function() {
    return z.object({
        hopeKitItemID: UUIDSchema
    });
});
export var ResumableAssetCreateInputSchema = z.lazy(function() {
    return z.object({
        context: z.string(),
        fileName: z.string(),
        key: z.string(),
        uploadType: UploadTypeSchema
    });
});
export var RoleAvivaConfigInputSchema = z.lazy(function() {
    return z.object({
        caringContactsMedium: CaringContactsMediumSchema,
        crisisFramework: CrisisFrameworkSchema,
        onboardingVariant: OnboardingVariantSchema,
        productVersion: ProductVersionSchema
    });
});
export var RoleInputSchema = z.lazy(function() {
    return z.object({
        createRole: CreateRoleInputSchema.nullish(),
        deleteRole: DeleteRoleInputSchema.nullish(),
        updateRole: UpdateRoleInputSchema.nullish()
    });
});
export var RolePractitionerInputSchema = z.lazy(function() {
    return z.object({
        practitionerID: UUIDSchema,
        primaryPractitioner: z.boolean()
    });
});
export var RoleProductConfigInputSchema = z.lazy(function() {
    return z.object({
        avivaConfig: RoleAvivaConfigInputSchema
    });
});
export var RoleSettingsInputSchema = z.lazy(function() {
    return z.object({
        changeBiteSettings: ChangeBiteRoleSettingsInputSchema
    });
});
export var SleepDiaryEntryInfluencerInputSchema = z.lazy(function() {
    return z.object({
        count: z.number().nullish(),
        duration: SleepDiaryEntryDurationSchema.nullish(),
        kinds: z.array(z.string()).nullish(),
        occurred: z.boolean(),
        timesOfDay: z.array(SleepDiaryEntryTimeOfDaySchema)
    });
});
export var SleepDiaryEntryInputSchema = z.lazy(function() {
    return z.object({
        alcohol: SleepDiaryEntryInfluencerInputSchema.nullish(),
        caffeine: SleepDiaryEntryInfluencerInputSchema.nullish(),
        deviceInBed: SleepDiaryEntryInfluencerInputSchema.nullish(),
        endTime: DateTimeSchema,
        exercise: SleepDiaryEntryInfluencerInputSchema.nullish(),
        medicine: SleepDiaryEntryInfluencerInputSchema.nullish(),
        napping: SleepDiaryEntryInfluencerInputSchema.nullish(),
        sleepDelay: SleepDiaryEntryDurationSchema.nullish(),
        startTime: DateTimeSchema,
        tobacco: SleepDiaryEntryInfluencerInputSchema.nullish(),
        wakeupCount: z.number(),
        wakeupDuration: SleepDiaryEntryDurationSchema.nullish()
    });
});
export var SnapshotQuizSetCollectionInputSchema = z.lazy(function() {
    return z.object({
        quizSetCollectionID: UUIDSchema
    });
});
export var SnapshotSessionInputSchema = z.lazy(function() {
    return z.object({
        sessionID: UUIDSchema
    });
});
export var StressBreathingExerciseInputSchema = z.lazy(function() {
    return z.object({
        rounds: z.array(StressBreathingRoundInputSchema)
    });
});
export var StressBreathingRoundInputSchema = z.lazy(function() {
    return z.object({
        distressRating: z.number().min(1).max(10).nullish()
    });
});
export var TestPatientInputSchema = z.lazy(function() {
    return z.object({
        caringContactsMedium: CaringContactsMediumSchema.nullish(),
        crisisFramework: CrisisFrameworkSchema.nullish(),
        onboardingVariant: OnboardingVariantSchema.nullish(),
        productSlug: z.string().nullish(),
        productStatic: z.boolean().nullish(),
        productVersion: ProductVersionSchema.nullish(),
        roleType: RoleTypeSchema.nullish()
    });
});
export var TestRoleInputSchema = z.lazy(function() {
    return z.object({
        practitionerEmails: z.array(z.string()).nullish(),
        productConfig: RoleProductConfigInputSchema.nullish(),
        productID: UUIDSchema,
        productStatic: z.boolean(),
        roleType: RoleTypeSchema,
        supporteeEmail: z.string().nullish(),
        ystNominationStatus: z.string().nullish()
    });
});
export var TestUserInputSchema = z.lazy(function() {
    return z.object({
        password: z.string().nullish(),
        roles: z.array(TestRoleInputSchema),
        user: CreateUserInputSchema
    });
});
export var TextItemInputSchema = z.lazy(function() {
    return z.object({
        ID: UUIDSchema,
        text: z.string()
    });
});
export var ThoughtDiaryEntryInputSchema = z.lazy(function() {
    return z.object({
        behavior: z.string(),
        event: z.string(),
        evidenceAgainst: z.array(TextItemInputSchema),
        evidenceFor: z.array(TextItemInputSchema),
        feelingsAfter: z.array(TextItemInputSchema),
        feelingsBefore: z.array(TextItemInputSchema),
        thoughtAfter: z.string(),
        thoughtBefore: z.string()
    });
});
export var UpdateActivityPracticeInputSchema = z.lazy(function() {
    return z.object({
        activity: ActivityInputSchema,
        practiceID: UUIDSchema,
        practiceValues: PracticeValuesInputSchema
    });
});
export var UpdateEatingLogEntryInputSchema = z.lazy(function() {
    return z.object({
        deleteImage: z.boolean().nullish(),
        eatingLogEntry: EatingLogEntryInputSchema,
        practiceID: UUIDSchema,
        practiceValues: PracticeValuesInputSchema
    });
});
export var UpdateHopeKitImageInputSchema = z.lazy(function() {
    return z.object({
        hopeKitItemID: UUIDSchema,
        reason: z.string().nullish()
    });
});
export var UpdateHopeKitQuoteInputSchema = z.lazy(function() {
    return z.object({
        author: z.string().nullish(),
        hopeKitItemID: UUIDSchema,
        reason: z.string().nullish(),
        text: z.string()
    });
});
export var UpdateHopeKitVideoInputSchema = z.lazy(function() {
    return z.object({
        hopeKitItemID: UUIDSchema,
        reason: z.string().nullish()
    });
});
export var UpdateOuiUserInputSchema = z.lazy(function() {
    return z.object({
        currentPassword: z.string().nullish(),
        email: z.string().nullish(),
        password: z.string().nullish(),
        person: PersonUpdateInputSchema.nullish()
    });
});
export var UpdateRelaxDiaryEntryPracticeInputSchema = z.lazy(function() {
    return z.object({
        practiceID: UUIDSchema,
        practiceValues: PracticeValuesInputSchema,
        relaxDiaryEntry: RelaxDiaryEntryInputSchema
    });
});
export var UpdateRoleInputSchema = z.lazy(function() {
    return z.object({
        organizationID: UUIDSchema.nullish(),
        practitioners: z.array(RolePractitionerInputSchema).nullish(),
        productConfig: RoleProductConfigInputSchema.nullish(),
        productID: UUIDSchema.nullish(),
        productStatic: z.boolean().nullish(),
        roleID: UUIDSchema,
        roleType: RoleTypeSchema.nullish(),
        supporteeID: UUIDSchema.nullish(),
        supporteeRelation: PatientSupporterRelationSchema.nullish()
    });
});
export var UpdateSessionInputSchema = z.lazy(function() {
    return z.object({
        agenda: z.array(z.string()).nullish(),
        completedIllustrationID: UUIDSchema.nullish(),
        contentType: z.string().nullish(),
        description: z.string().nullish(),
        groupID: UUIDSchema,
        illustrationID: UUIDSchema.nullish(),
        locale: z.string().nullish(),
        name: z.string().nullish(),
        order: z.number().nullish(),
        sessionID: UUIDSchema,
        statusID: z.number().nullish(),
        variantID: UUIDSchema
    });
});
export var UpdateSleepDiaryEntryPracticeInputSchema = z.lazy(function() {
    return z.object({
        practiceID: UUIDSchema,
        practiceValues: PracticeValuesInputSchema,
        sleepDiaryEntry: SleepDiaryEntryInputSchema
    });
});
export var UpdateThoughtDiaryEntryPracticeInputSchema = z.lazy(function() {
    return z.object({
        practiceID: UUIDSchema,
        practiceValues: PracticeValuesInputSchema,
        thoughtDiaryEntry: ThoughtDiaryEntryInputSchema
    });
});
export var UpdateUserInputSchema = z.lazy(function() {
    return z.object({
        addresses: z.array(AddressInputSchema).nullish(),
        birthDate: DateSchema.nullish(),
        email: z.string().email().nullish(),
        familyName: z.string().nullish(),
        genderIdentity: UserGenderIdentitySchema.nullish(),
        givenName: z.string().nullish(),
        locale: z.string().nullish(),
        militaryStatus: UserMilitaryStatusSchema.nullish(),
        phone: z.string().nullish(),
        race: UserRaceSchema.nullish(),
        settings: UserSettingsInputSchema.nullish(),
        sexualOrientation: UserSexualOrientationSchema.nullish(),
        timezone: z.string().nullish()
    });
});
export var UserAccessLogRequestInputSchema = z.lazy(function() {
    return z.object({
        userID: UUIDSchema
    });
});
export var UserAddressInputSchema = z.lazy(function() {
    return z.object({
        city: z.string(),
        country: z.string(),
        line1: z.string(),
        line2: z.string(),
        state: z.string().nullish(),
        zip: z.string().nullish()
    });
});
export var UserDemoInputSchema = z.lazy(function() {
    return z.object({
        DOB: DateSchema.nullish(),
        gender: LegacyUserGenderSchema.nullish(),
        isVeteran: z.boolean().nullish(),
        race: LegacyUserRaceSchema.nullish(),
        sexuality: LegacyUserSexualitySchema.nullish()
    });
});
export var UserNameInputSchema = z.lazy(function() {
    return z.object({
        first: z.string(),
        last: z.string(),
        pfx: z.string().nullish(),
        preferred: z.string().nullish(),
        sfx: z.string().nullish()
    });
});
export var UserSettingsInputSchema = z.lazy(function() {
    return z.object({
        emailPreferred: z.boolean().nullish(),
        phonePreferred: z.boolean().nullish()
    });
});
export var UserUsageInputSchema = z.lazy(function() {
    return z.object({
        after: DateSchema.nullish(),
        before: DateSchema.nullish(),
        duration: UsageDurationSchema,
        productSlug: z.string().nullish(),
        roleID: UUIDSchema.nullish()
    });
});
export var UserUsageSummaryInputSchema = z.lazy(function() {
    return z.object({
        after: DateSchema.nullish(),
        before: DateSchema.nullish(),
        productSlug: z.string().nullish(),
        roleID: UUIDSchema.nullish()
    });
});
export var WordPairingInputSchema = z.lazy(function() {
    return z.object({
        rounds: z.array(WordPairingRoundInputSchema)
    });
});
export var WordPairingRoundInputSchema = z.lazy(function() {
    return z.object({
        numAnswers: z.number().nonnegative().max(40),
        numCorrectAnswers: z.number().nonnegative().max(40),
        time: z.number().nonnegative()
    });
});
export var WordPairingWidgetWordPairingsInputSchema = z.lazy(function() {
    return z.object({
        after: DateSchema.nullish(),
        before: DateSchema.nullish(),
        limit: z.number().nullish()
    });
});
export var YSTPatientInputSchema = z.lazy(function() {
    return z.object({
        birthDate: DateSchema.nullish(),
        person: PersonWithEmailInputSchema
    });
});
export var YstNominationCreateInputSchema = z.lazy(function() {
    return z.object({
        email: z.string().email().nullish(),
        familyName: z.string(),
        givenName: z.string(),
        phone: z.string().nullish(),
        relation: z.string()
    });
});
export var YstNominationRejectInputSchema = z.lazy(function() {
    return z.object({
        reason: z.string(),
        ystNominationID: z.string()
    });
});
export var YstNominationUpdateInputSchema = z.lazy(function() {
    return z.object({
        email: z.string().nullish(),
        familyName: z.string().nullish(),
        givenName: z.string().nullish(),
        phone: z.string().nullish(),
        ystNominationID: z.string()
    });
});
